import { Box } from '@mui/material';

import { AuthProvider } from '@/contexts/AuthContext';
import { useResponsiveSidebarOpen } from '@/hooks/useResponsiveSidebarOpen';
import layoutSizes from '../../utils/layoutSizes';
import Header from '../common/Header';
import MenuSidebar from '../common/MenuSidebar';
import Toast from '../common/Toast';

type LayoutAdminProps = {
	children: React.ReactNode;
};

const LayoutAdmin = ({ children }: LayoutAdminProps) => {
	const [isSidebarOpen, setIsSidebarOpen] = useResponsiveSidebarOpen();

	return (
		<AuthProvider>
			<Box
				sx={{
					height: '100%',
					width: isSidebarOpen
						? { xs: '100%', md: `calc(100% - ${layoutSizes.sidebarWidth}px)` }
						: { xs: '100%', md: 'calc(100% - 76px)' },
					ml: isSidebarOpen
						? { xs: 0, md: `${layoutSizes.sidebarWidth}px` }
						: { xs: 0, md: '76px' },
					pt: `${layoutSizes.headerHeight}px`,
				}}
			>
				<Box sx={{ height: '100%' }}>
					<MenuSidebar
						isSidebarOpen={isSidebarOpen}
						setIsSidebarOpen={setIsSidebarOpen}
						isAdmin
					/>
					<Header
						isMenuSidebarOpen={isSidebarOpen}
						setIsMenuSidebarOpen={setIsSidebarOpen}
					/>
					<Box
						component="main"
						sx={{
							flexGrow: 1,
							bgcolor: 'background.default',
							p: 3,
							height: '100%',
						}}
					>
						{children}
					</Box>
				</Box>
				<Toast />
			</Box>
		</AuthProvider>
	);
};

export default LayoutAdmin;
